import moment from 'moment'
import * as ListDataManager from 'dataContainer/listDataManager'

export function setCellType(templateField) {
  const governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field
  const cellShowsPreviousValues =
    governanceOwner.validation && governanceOwner.validation.show_previous
  const cellShowsSuggestions =
    governanceOwner.validation &&
    governanceOwner.validation.suggestion_list &&
    governanceOwner.suggestions &&
    governanceOwner.suggestions.length

  if (cellShowsPreviousValues && cellShowsSuggestions) {
    templateField.type = 'autocomplete'
    templateField.strict = false
    templateField.filter = true
    // Array.from(new Set(items))
    templateField.source = Array.from(
      new Set([...governanceOwner.previous_values, ...governanceOwner.suggestions]),
    )
  } else if (cellShowsPreviousValues) {
    templateField.type = 'autocomplete'
    templateField.strict = false
    templateField.filter = true
    templateField.source = governanceOwner.previous_values
  } else if (cellShowsSuggestions) {
    templateField.type = 'autocomplete'
    templateField.strict = false
    templateField.filter = true
    templateField.source = governanceOwner.suggestions
  } else if (governanceOwner.governance_type === 'list') {
    if (governanceOwner.list_governance && governanceOwner.list_governance.multi) {
      templateField.divider = governanceOwner.list_governance.delimiter
      templateField.multi = true
    }

    templateField.type = 'autocomplete'
    templateField.strict = true
    templateField.filter = true

    const listGovernance = (governanceOwner && governanceOwner.list_governance) || {}
    const uniqueColumnValues = ListDataManager.getUniqueValuesForListColumn(
      listGovernance.list_id,
      listGovernance.list_column_id,
    )

    // assign the first set of valid values
    // clone the unique values so the originals remain unmodified.  this may be unnecessary, but i did it for safety
    templateField.source = JSON.parse(JSON.stringify(uniqueColumnValues))

    const type =
      governanceOwner.list_governance &&
      governanceOwner.list_governance.lists &&
      governanceOwner.list_governance.lists.type

    if (type === 'drill-down') {
      if (
        governanceOwner.list_governance.meta.allColumnsInList[0] &&
        governanceOwner.list_governance.meta.allColumnsInList[0].field.list_governance
      ) {
        templateField.divider =
          governanceOwner.list_governance.meta.allColumnsInList[0].field.list_governance.delimiter
        // This first column of a drill-down list is the parent column, and sets the multi value for the entire list.
        templateField.multi =
          !!governanceOwner.list_governance.meta.allColumnsInList[0].field.list_governance.multi
      }
      if (governanceOwner.list_governance.hierarchy) {
        templateField.source = [...new Set(templateField.source)]
        templateField.hierarchy = true
        templateField.indicator = governanceOwner.list_governance.indicator
      } else {
        templateField.source = [...new Set(templateField.source)]
      }
    }
  } else if (
    governanceOwner.governance_type === 'date' ||
    governanceOwner.segment_type === 'date'
  ) {
    templateField.type = 'date'
    // const formatString = convertDateFieldToMomentJsFormat(
    //    templateField.field
    // );
    const formatString = moment.defaultFormat
    templateField.dateFormat = formatString
    templateField.allowEmpty = !!templateField.required

    templateField.datePickerConfig = {
      theme: 'claravine',
      format: formatString,
    }
  }
  return templateField
}
